module.exports = __webpack_public_path__ + "img/author1.a180d7d1.jpg";